// extracted by mini-css-extract-plugin
export var container = "_8z-0";
export var icon = "_8z-1";
export var text = "_8z-2";